// SignupButtons.jsx

import React from 'react';

// Constants
import { SIGNUPS_ENABLED, SIGNUPS_PAUSED_MESSAGE } from 'login/signupAvailability';

// CSS
import './SignupButtons.css';

// Components
import SignupButton from './button/SignupButton';
import google from 'images/google.png';

/**
 * SignupButtons
 *
 * Google / email signup actions shown below the sign-in form.
 *
 * @param {Function} onEmailClick - Handler for email signup.
 * @param {Function} onGoogleClick - Handler for Google signup.
 *
 * @returns {ReactNode} - SignupButtons.
 */
const SignupButtons = React.memo(({ onEmailClick, onGoogleClick }) => {

    // ----- RENDER ----- //

    return (

        <div className="signup-buttons-container">

            {/* SPACER */}
            <div className="signup-buttons-spacer">

                {/* SPACER BAR */}
                <div
                  className="signup-buttons-spacer-bar"
                >

                </div>

                {/* SPACER OR */}
                <div
                  className="signup-buttons-spacer-or"
                >
                    OR
                </div>

                {/* SPACER BAR */}
                <div
                  className="signup-buttons-spacer-bar"
                >

                </div>

            </div>

            <SignupButton
              image={google}
              label="Continue with Google"
              onClick={onGoogleClick}
            />

            {/* SPACER */}
            <div className="signup-buttons-spacer">

                {/* SPACER BAR */}
                <div
                  className="signup-buttons-spacer-bar"
                >

                </div>

                {/* SPACER OR */}
                <div
                  className="signup-buttons-spacer-or"
                >
                    OR
                </div>

                {/* SPACER BAR */}
                <div
                  className="signup-buttons-spacer-bar"
                >

                </div>

            </div>

            {/* WRAPPER */}
            <div className="signup-buttons-email-wrapper">

                {/* EMAIL */}
                <div
                  aria-disabled={!SIGNUPS_ENABLED}
                  className={`signup-buttons-email${!SIGNUPS_ENABLED ? ' signup-buttons-email-disabled' : ''}`}
                  role={SIGNUPS_ENABLED ? 'button' : undefined}
                  tabIndex={SIGNUPS_ENABLED ? 0 : undefined}
                  onClick={SIGNUPS_ENABLED ? onEmailClick : undefined}
                  onKeyDown={SIGNUPS_ENABLED ? ((e) => {
                    if (e.key === 'Enter' || e.key === ' ') onEmailClick?.(e);
                  }) : undefined}
                >
                    Sign up free with email.
                </div>

                {/* NOTICE */}
                <div
                  className={SIGNUPS_ENABLED ? 'signup-buttons-cc' : 'signup-buttons-notice'}
                >
                    {SIGNUPS_ENABLED
                      ? 'No credit card required'
                      : SIGNUPS_PAUSED_MESSAGE}
                </div>

            </div>

        </div>
    );

});

// Dev Tools
SignupButtons.displayName = 'SignupButtons';

export default SignupButtons;
